module.exports = __webpack_public_path__ + "img/scrumorg.e082cedc.png";